import { IoPersonOutline } from "react-icons/io5";
import { HiAdjustments } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { NotificationMenu } from "../../components/NotificationMenu";
import { SettingsMenu } from "../../components/SettingsMenu";
import { useGetCurrentUser } from "@/hooks/useUser";
import { Spinner } from "@/components/Spinner";
import { formatPhone } from "@/utils/formatPhone";

export const Profile = () => {
  const navigate = useNavigate();
  const { data: user, isLoading } = useGetCurrentUser();

  const handleSettingsClick = (id: string) => {
    navigate(`/settings/${id}`);
  };

  if (isLoading) {
    return (
      <div className="bg-[#f5f5f5] min-h-screen pt-20 pb-20 flex items-center justify-center">
        <Spinner />
      </div>
    );
  }

  const displayName =
    user?.profile?.fullName ||
    `${user?.firstName} ${user?.lastName}` ||
    "Usuário";
  const displayCpf = user?.profile?.cpf || "***.***.***-**";
  const displayPhone = user?.profile?.phone
    ? formatPhone(user.profile.phone)
    : null;

  return (
    <div className="bg-[#f5f5f5] min-h-screen pt-20 pb-20">
      <div className="flex justify-center">
        <div className="w-[95%] lg:w-[98%]">
          <div className="w-full bg-white p-5 mt-5 rounded-[18px] shadow-sm flex items-center justify-between">
            <div className="flex items-center gap-5">
              <div className="w-15 h-15 rounded-full bg-[hsl(var(--primary))]/20 flex items-center justify-center">
                <IoPersonOutline className="text-[hsl(var(--primary))] text-[35px]" />
              </div>
              <div className="flex flex-col">
                <span className="text-[20px] font-semibold">{displayName}</span>
                <span className="text-gray-500 font-medium text-[15px]">
                  {user?.email || "email@example.com"}
                </span>
                <span className="text-gray-500 font-medium text-[15px]">
                  CPF: {displayCpf}
                </span>
                {displayPhone && (
                  <span className="text-gray-500 font-medium text-[15px]">
                    Tel: {displayPhone}
                  </span>
                )}
              </div>
            </div>
            <div onClick={() => navigate("/profile/change-profile")}>
              <HiAdjustments className="text-gray-400 text-[25px] ml-5 cursor-pointer hover:text-gray-600 transition ease-in-out duration-300" />
            </div>
          </div>

          <NotificationMenu title="Notificações" />

          <SettingsMenu
            title="Configurações"
            onOptionClick={handleSettingsClick}
          />
        </div>
      </div>
    </div>
  );
};
